import React, { Component } from "react";

import AddTodoForm from "./AddTodoForm";
import Todo from "./Todo";
import SearchBar from "./SearchBar";

export class TodoList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			todos: [],
			todoText: "",
			errorMessage: "",
			updateCurrentTodo: null,
			todoNewBody: "",
			searchedTodo: "",
			isSearchOpen: false,
		};
		this.inputRef = React.createRef();
	}

	componentDidMount() {
		const todos = JSON.parse(localStorage.getItem("todos")) || [];

		if (todos == null || todos.length == 0) {
			this.setState({
				errorMessage: "You don't have any todos",
			});
		} else {
			this.setState({
				todos,
			});
		}
	}

	componentDidUpdate(props, state) {
		if (this.state.todos != state.todos) {
			localStorage.setItem("todos", JSON.stringify(this.state.todos));
		}
	}

	updateInputText = (e) => {
		this.setState({
			todoText: e.target.value,
		});
	};

	addTodoSubmission = () => {
		const todoText = this.state.todoText;
		const allTodos = [...this.state.todos];

		let newTodo;

		if (todoText != "") {
			const isExist = allTodos.some((todo) => todo.body == todoText);

			if (!isExist) {
				newTodo = {
					id: new Date().getTime(),
					body: todoText,
					completed: false,
				};

				this.setState({
					todos: [...allTodos, newTodo],
					errorMessage: "",
					todoText: "",
				});
			} else {
				this.setState({
					errorMessage: "The todo is already exist",
				});
			}
		}
	};

	deleteTodo = (id) => {
		const allTodos = [...this.state.todos];
		const filteredTodos = allTodos.filter((todo) => todo.id != id);

		this.setState({
			todos: filteredTodos,
			errorMessage: filteredTodos.length == 0 ? "You don't have any todos." : "",
		});
	};

	updateTodoSubmission = (id) => {
		const allTodos = [...this.state.todos];
		const todo = allTodos.find((todo) => todo.id == id);

		todo.body = this.state.todoNewBody;

		this.setState({
			todos: allTodos,
			todoNewBody: "",
		});
	};

	completeTodoHanlder = (id) => {
		const allTodos = [...this.state.todos];
		const todo = allTodos.find((todo) => todo.id == id);
		todo.completed = !todo.completed;

		this.setState({
			todos: allTodos,
		});
	};

	updateNewTodoBody = (e) => {
		this.setState({
			todoNewBody: e.target.value,
		});
	};

	mapThroughTodos = (todos) => {
		return todos.map((todo) => (
			<Todo
				key={todo.id}
				todoText={this.state.todoNewBody}
				updateTodoSubmission={this.updateTodoSubmission}
				updateText={this.updateNewTodoBody}
				changeUpdateOpen={this.updateOpenHandler}
				deleteTodo={this.deleteTodo}
				todo={todo}
				completeTodo={this.completeTodoHanlder}
				cancelUpdate={this.cancelUpdateHandler}
			/>
		));
	};

	updateSearchedTodo = (text) => {
		this.setState({
			searchedTodo: text,
		});
	};

	searchBarVisibility = () => {
		this.setState((current) => {
			return {
				isSearchOpen: !current.isSearchOpen,
			};
		});
	};

	render() {
		const errorMessage = this.state.errorMessage;
		const searchedTodo = this.state.searchedTodo;
		const isSearchOpen = this.state.isSearchOpen;

		let mappedTodos;

		if (!isSearchOpen) {
			mappedTodos = this.mapThroughTodos(this.state.todos);
		} else {
			if (searchedTodo == "") {
				mappedTodos = this.mapThroughTodos(this.state.todos);
			} else {
				const allTodos = [...this.state.todos];
				const searchedTodos = allTodos.filter((todo) => {
					const regex = new RegExp(searchedTodo, "i");
					return todo.body.search(regex) != -1;
				});
				mappedTodos = this.mapThroughTodos(searchedTodos);
			}
		}

		return (
			<div className="todolist-container">
				<h1 className="main-title">What's the plan for today?</h1>
				<AddTodoForm
					todos={this.state.todos}
					wannaDetails={this.state.wannaAddDetails}
					updateDetails={this.addTodoDetails}
					todoDetails={this.state.todoDetails}
					todoText={this.state.todoText}
					addTodoSubmission={this.addTodoSubmission}
					updateText={this.updateInputText}
					inputRef={this.inputRef}
				/>
				{errorMessage == "" ? null : <h3 className="no-todos-warning">{errorMessage}</h3>}
				{this.state.todos.length != 0 ? (
					<SearchBar
						searchBarVisibility={this.searchBarVisibility}
						isSearchOpen={this.state.isSearchOpen}
						updateSearch={this.updateSearchedTodo}
					/>
				) : null}
				<div className="todos-container">{mappedTodos}</div>
			</div>
		);
	}
}

export default TodoList;
